<template>
  <img
    src="@/assets/task-handle-right.svg"
    alt=""
    draggable="false"
    class="handle-right"
    @click.stop
    @mousedown="$emit('mousedown', $event)"
  />
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.handle-right {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  user-select: none;
  transform: translateX(100%);
}
</style>
